var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.916,
    height: 37.987,
    viewBox: "0 0 41.916 37.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile_Photo",
    "data-name": "Profile Photo",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-photo",
    transform: "translate(0 4.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M12.5,5.628A5.557,5.557,0,0,1,16.427,4h6.8a1.852,1.852,0,1,1,0,3.7h-6.8a1.852,1.852,0,0,0-1.31.543L13.583,9.782a5.557,5.557,0,0,1-3.929,1.628h-3.1A1.852,1.852,0,0,0,4.7,13.262V31.785a1.852,1.852,0,0,0,1.852,1.852H32.49a1.852,1.852,0,0,0,1.852-1.852V18.819a1.852,1.852,0,0,1,3.7,0V31.785a5.557,5.557,0,0,1-5.557,5.557H6.557A5.557,5.557,0,0,1,1,31.785V13.262A5.557,5.557,0,0,1,6.557,7.7h3.1a1.852,1.852,0,0,0,1.31-.543Z",
    transform: "translate(-1 -4)",
    fill: "#3e3e3e",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M6,18.262a9.262,9.262,0,1,1,9.262,9.262A9.262,9.262,0,0,1,6,18.262ZM15.262,12.7a5.557,5.557,0,1,0,5.557,5.557A5.557,5.557,0,0,0,15.262,12.7Z",
    transform: "translate(3.262 0.262)",
    fill: "#3e3e3e",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(27.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M16,5.692A1.692,1.692,0,0,1,17.692,4H27.844a1.692,1.692,0,1,1,0,3.384H17.692A1.692,1.692,0,0,1,16,5.692Z",
    transform: "translate(-16 1.076)",
    fill: "#3e3e3e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M20.692,1a1.692,1.692,0,0,1,1.692,1.692V12.844a1.692,1.692,0,0,1-3.384,0V2.692A1.692,1.692,0,0,1,20.692,1Z",
    transform: "translate(-13.924 -1)",
    fill: "#3e3e3e",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePhoto);
export default __webpack_public_path__ + "static/media/ProfilePhoto.8d91f2cee4170c46d507fd5a5b637028.svg";
export { ForwardRef as ReactComponent };